var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.updateValue}}),_c('span',{staticClass:"checkbox-label"},[_vm._v(_vm._s(_vm.labelText))])])}
var staticRenderFns = []

export { render, staticRenderFns }